function getViewport(): string {
  return `${window.innerWidth}x${window.innerHeight}`;
}

export function setTrackingHeaders(headers: Headers): void {
  const appVersion = import.meta.env.VITE_APP_VERSION;
  if (appVersion) {
    headers.set("X-Aiera-App-Version", appVersion);
  }

  headers.set("X-Aiera-App-Id", "viewer");
  headers.set("X-Aiera-Viewport", getViewport());
  headers.set(
    "X-Aiera-Timezone",
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );
}
